export default __webpack_public_path__ + "static/media/placeholder_dummy2016-personaltrainer01-mobile-de.83003b8c.png";